import { ReactNode, type FC } from 'react';
import { TriangleAlert, LoaderCircle } from 'lucide-react';
import { cn } from '@matrix-forge/ui/lib/utils';

interface StateMessageProps {
  className?: string;
  title?: string;
  description?: string | ReactNode;
  icon?: FC<{ className: string }>;
  isError?: boolean;
  isLoading?: boolean;
}

/**
 * Renders a friendly message to end-user when the UI is some atypical state, for
 * example when a dataset is empty or an error has occurred.
 */
export const StateMessage: FC<StateMessageProps> = ({
  className,
  title,
  description,
  icon: Icon,
  isLoading,
  isError,
}) => {
  let iconContent: ReactNode = null;
  if (Icon) {
    iconContent = <Icon className="w-5 h-5 text-muted-foreground mx-auto mb-4" />;
  } else if (isError) {
    iconContent = <TriangleAlert className="w-5 h-5 text-muted-foreground mx-auto mb-4" />;
  } else if (isLoading) {
    iconContent = <LoaderCircle className="w-5 h-5 mx-auto mb-4 animate-spin" />;
  }
  return (
    <div
      className={cn('mf-state-message w-full h-full flex items-center justify-center', className)}
    >
      <div className="text-center">
        {!!iconContent && iconContent}
        {!!title && <p className="text-muted-foreground mb-4">{title}</p>}
        {!!description && <p className="text-sm text-muted-foreground">{description}</p>}
      </div>
    </div>
  );
};
